import React from 'react'
import './Loader.css'


const Loader = (props) => {
    return(
        <div className="Loader">

        </div>
    )
}


export default Loader